module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-60x60-ef47a71354ae5b9193036970ae67ac48.png";